import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { TGamblingSessionNotification } from 'js/hooks/socket/types';

export const useHandleGamblingSessionNotification = () => {
    const dispatch = useDispatch();

    return useCallback((response: TGamblingSessionNotification) => {
        const { data: { showMessage = {} } } = response;
        const message = showMessage?.showMessageNotificationInfo?.message;

        if (!message) {
            return;
        }

        dispatch(showCommonPopupAction({
            title: 'playtech.mobile.system.message.congratulations',
            content: message
        }));
    }, [dispatch]);
};
